import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';

@Component({
  selector: 'app-tab-landing',
  templateUrl: './tab-landing.component.html',
  styleUrls: ['./tab-landing.component.css']
})
export class TabLandingComponent implements OnInit, OnDestroy {
  @Input() tabData: any;
  @Input() config: any;
  @Input() tenantType: any;
  @Input() refreshRate: any;
  @Input() fromDate: any;
  @Input() toDate: any;

  tenantConfig: any = null;
  osFlag:boolean = true;
  private _subscription: Subscription;

  profileTabList: any[] = [];
  // [
  // DVR
  // { id: 'vitalsHistory', label: 'Vitals History', isActive: true },
  // { id: 'attributesChart', label: 'Vitals Chart', isActive: true },
  // CNP
  // { id: 'monotainerHistory', label: 'Monotainer History', isActive: true }
  // TRL
  // { id: 'rulStatistics', label: 'RUL Statistics', isActive: true },
  // { id: 'attributesChart', label: 'Telematics Statistics', isActive: true },
  // { id: 'telematicsHistory', label: 'Telematics History', isActive: true },
  // DMK
  // { id: 'telematicsHistory', label: 'Appliance History', isActive: true },
  // { id: 'attributesChart', label: 'Appliance Statistics', isActive: true },
  // CRA
  // { id: 'attributesChart', label: 'Attributes', isActive: true, attributeType: 'attributes' },
  // { id: 'attributesChart', label: 'System Attributes', isActive: true, attributeType: 'systemAttributes' },
  // AHK && DMR
  // { id: 'vehicleStatistics', label: 'Vehicle Statistics', isActive: true },
  // { id: 'historyPlayBack', label: 'History PlayBack', isActive: true },
  // { id: 'insights', label: 'Insights', isActive: true },
  // COMMON
  // { id: 'alerts', label: 'Alerts', isActive: this.service?.rbacManagement(60) }
  // ];
  selectedTabIndex: number = 0;
  genericFilterData: any = null;
  constructor(
    public service: ServicecallService,
    private _dataSer: DataService
  ) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'navigateToAlert') {
        this.selectedTabIndex = this.profileTabList.findIndex(
          (item) => item.id === 'alerts'
        );
        this._dataSer.broadcast('scrollTop', 'alert');
      }
    });
  }

  ngOnInit(): void {
    this.tenantConfig = this.service.getConfiguration('tenantGenericConfig')
      ? this.service.getConfiguration('tenantGenericConfig')
      : null;
    const currentProfile = this._getCurrentProfile(
      this.tenantConfig,
      this.tabData?.category
    );
    this.profileTabList = currentProfile?.entityProfileTabList?.length
      ? currentProfile?.entityProfileTabList
      : (this.tenantConfig?.entityProfileTabList?.length ? this.tenantConfig?.entityProfileTabList : []);
    if (this.service?.rbacManagement('vehicles_DescriptiveAnalysis')) {
      this.profileTabList.push({
        id: 'descriptiveAnalysis',
        label: 'Descriptive Analysis',
        isActive: this.service?.rbacManagement('vehicles_DescriptiveAnalysis')
      });
    }
    if (!this.service?.rbacManagement('vehicles_Enrolled_DTC')) {
      this.profileTabList = this.profileTabList.filter(item => item.id !== 'dtc');
    }
    if (!this.service?.rbacManagement('vehicles_Enrolled_NoDTC')) {
      this.profileTabList = this.profileTabList.filter(item => item.id !== 'noDtc');
    } 
    if (!this.service?.rbacManagement('vehicles_Enrolled_DTCTrails')) {
      this.profileTabList = this.profileTabList?.filter(item => item?.id !== 'dtcTrails');
    }
    if (!this.service?.rbacManagement('vehicles_Enrolled_DTCPredictions')) {
      this.profileTabList = this.profileTabList?.filter(item => item?.id !== 'dtcPredictions');
    }
    this.profileTabList.push({
      id: 'alerts',
      label: 'Alerts',
      isActive: this.service.rbacManagement('entities_Alerts')
    });
    this.osFlag = this._getEntityOs();
  }

  tabChanged(event: any) {
    this.selectedTabIndex = event.index;
  }

  onGenericFilterChange(filterEvent: any) {
    this.genericFilterData = filterEvent;
    this._dataSer.broadcast('pageSizeChange');
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }

  /**
   * Gets current profile
   * @param tenantConfig 
   * @param category 
   * @returns  
   */
  private _getCurrentProfile(tenantConfig: any, category: string) {
    return tenantConfig?.profile?.find((value) => value?.category === category);
  }

  private _getEntityOs(): boolean {
    return this.tabData?.device?.os === 'windows' ? true : false;
  }
}
